import * as React from "react";
import {
  Dialog as RadixDialog,
  DialogPortal,
  DialogOverlay,
  DialogContent as RadixContent,
  DialogTitle as RadixTitle,
} from "@radix-ui/react-dialog";

export function Dialog({ children, open, onOpenChange }) {
  return <RadixDialog open={open} onOpenChange={onOpenChange}>{children}</RadixDialog>;
}

export function DialogContent({ children }) {
  return (
    <DialogPortal>
      <DialogOverlay className="fixed inset-0 bg-black/50 z-50" />
      <RadixContent className="fixed z-50 bg-white p-6 rounded-2xl shadow-xl w-full max-w-md top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        {children}
      </RadixContent>
    </DialogPortal>
  );
}

export function DialogHeader({ children }) {
  return <div className="mb-4">{children}</div>;
}

export function DialogTitle({ children }) {
  return <RadixTitle className="text-xl font-semibold">{children}</RadixTitle>;
}

export function DialogFooter({ children }) {
  return <div className="mt-6 flex justify-end gap-2">{children}</div>;
}
